import { makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ProductItem from "../ProductItem/ProductItem";
import { Category } from "../../Types/Types";

export const useStyles = makeStyles(() => ({
  category: {
    height: 50,
    backgroundColor: "#ededed",
    display: "flex",
    alignItems: "center",
    padding: "0px 20px",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  categoryName: {
    color: "#4c4c4c",
    fontWeight: "bold",
  },
  categorySection: {
    margin: "10px 0px",
  },
  productList: {
    display: "flex",
    flexFlow: "wrap",
  },
}));

export interface CategoryGroupProps {
  selectedCategoryId: number;
  category: Category;
  setSelectedCategoryId: (id: number | null) => void;
  loadArticle: (id: string) => void;
}

const CategoryGroup = (props: CategoryGroupProps) => {
  const classes = useStyles();
  const [selectedProduct, setSelectedProduct] = useState<null | string>(null);
  const {
    selectedCategoryId,
    category,
    setSelectedCategoryId,
    loadArticle,
  } = props;

  return (
    <div className={classes.categorySection}>
      <div
        className={classes.category}
        onClick={() => {
          setSelectedProduct(null);
          setSelectedCategoryId(
            selectedCategoryId === category.id ? null : category.id
          );
        }}
      >
        <Typography className={classes.categoryName} variant="body1">{t('overview.' + category.category)}</Typography>
        {category.id === selectedCategoryId ? (
          <KeyboardArrowDownIcon />
        ) : (
          <KeyboardArrowRightIcon />
        )}
      </div>
      <div
        className={classes.productList}
        style={{ height: category.id === selectedCategoryId ? 'auto' : 0 }}
      >
        {category.id === selectedCategoryId &&
          category.items.map((item,i) => (
            <ProductItem
              key={i}
              item={item}
              selectedProduct={selectedProduct}
              setSelectedProduct={(identifier) =>
                setSelectedProduct(identifier)
              }
              loadArticle={(id) => {
                loadArticle(id);
              }}
            />
        ))}
      </div>
    </div>
  );
};

export default CategoryGroup;
